export default "__VITE_ASSET__dywTLkP2__"